import { render } from "./Educationdb.vue?vue&type=template&id=1d67fb9b&scoped=true"
import script from "./Educationdb.vue?vue&type=script&lang=js"
export * from "./Educationdb.vue?vue&type=script&lang=js"

import "./Educationdb.vue?vue&type=style&index=0&id=1d67fb9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d67fb9b"]])

export default __exports__